module.exports = __webpack_public_path__ + "static/img/financing-apply-icon.f8cef038.png";